export const TZ = 'Europe/Riga';

const TIME_FMT = new Intl.DateTimeFormat('en-GB', {
  timeZone: TZ,
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

const DATE_FMT = new Intl.DateTimeFormat('en-GB', {
  timeZone: TZ,
  weekday: 'short',
  day: '2-digit',
  month: 'short',
});

const DATE_LONG = new Intl.DateTimeFormat('en-GB', {
  timeZone: TZ,
  weekday: 'long',
  day: '2-digit',
  month: 'long',
});

const DAY_KEY = new Intl.DateTimeFormat('en-CA', {
  timeZone: TZ,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

export function rigaTime(iso: string): string {
  return TIME_FMT.format(new Date(iso));
}
export function rigaDate(iso: string): string {
  return DATE_FMT.format(new Date(iso));
}
export function rigaDateLong(iso: string): string {
  return DATE_LONG.format(new Date(iso));
}
export function rigaDayKey(iso: string): string {
  return DAY_KEY.format(new Date(iso));
}

export function relativeKickoff(iso: string): string {
  const ms = new Date(iso).getTime() - Date.now();
  if (ms <= 0) return 'now';
  const mins = Math.round(ms / 60_000);
  if (mins < 60) return `in ${mins}m`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `in ${hrs}h`;
  const days = Math.round(hrs / 24);
  return `in ${days}d`;
}

export function stageLabel(stage: string): string {
  return {
    group: 'Group',
    r32: 'R32',
    r16: 'R16',
    qf: 'QF',
    sf: 'SF',
    third: '3rd',
    final: 'Final',
  }[stage] ?? stage;
}
